export const MODAL_TYPE_SURVEY_CREATE = 'MODAL_TYPE_SURVEY_CREATE';
